import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  FaHome,
  FaGamepad,
  FaUser,
  FaBars,
  FaHistory,
  FaShoppingBag,
  FaWallet,
  FaTrophy,
} from 'react-icons/fa';
import { GiTwoCoins, GiCardPickup } from 'react-icons/gi';
import { openDrawerAction } from '../redux/actions/OpenDrawerAction';
import './Footer.css';
const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const token = useSelector((state) => state.userTokenReducer?.token);
  const drawer = useSelector((state) => state.OpenDrawerReducer?.drawer);
  const userDetail = useSelector(
    (state) => state?.userDetailReducer?.userDetail,
  );
  const coinDetails = useSelector(
    (state) => state.coinDetailReducer?.coinDetail,
  );

  const isActive = (path) => location.pathname === path;

  // Basic User Footer
  if (token && userDetail?.role === 'basic') {
    const basicMenuItems = [
      { path: '/homes', icon: <FaHome />, label: 'Home' },
      { path: '/order-history', icon: <FaHistory />, label: 'Orders' },
      { path: '/product-details', icon: <FaShoppingBag />, label: 'Products' },
      { path: '/basic-profile', icon: <FaUser />, label: 'Profile' },
    ];

    return (
      <footer className="fixed bottom-0 left-0 right-0 w-full bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white shadow-[0_-4px_20px_rgba(0,0,0,0.3)] z-50 border-t border-gray-700">
        {/* Balance Display */}
        <div className="px-4 py-2 bg-gradient-to-r from-blue-900 to-purple-900 border-b border-gray-700">
          <div className="flex items-center justify-center gap-2 text-sm">
            <GiTwoCoins className="text-yellow-400" />
            <span className="font-semibold">Balance:</span>
            <span className="font-bold text-yellow-300">
              ₹{coinDetails?.amount || '0.00'}
            </span>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex justify-around items-center py-3">
          {basicMenuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center relative transition-all duration-300 ${
                isActive(item.path)
                  ? 'text-yellow-400 scale-110'
                  : 'text-gray-300 hover:text-white'
              }`}
            >
              {/* Active Indicator */}
              {isActive(item.path) && (
                <div className="absolute -top-3 w-10 h-1 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-b-full"></div>
              )}

              <div
                className={`icon-wrapper ${
                  isActive(item.path) ? 'active' : ''
                }`}
              >
                {item.icon}
              </div>

              <span className="text-xs font-semibold mt-1">{item.label}</span>
            </Link>
          ))}

          {/* Menu Button */}
          <button
            onClick={() => dispatch(openDrawerAction(!drawer))}
            className={`flex flex-col items-center relative transition-all duration-300 ${
              drawer
                ? 'text-purple-400 scale-110'
                : 'text-gray-300 hover:text-white'
            }`}
          >
            <div className={`icon-wrapper ${drawer ? 'active' : ''}`}>
              <FaBars />
            </div>
            <span className="text-xs font-semibold mt-1">Menu</span>
          </button>
        </nav>
      </footer>
    );
  }

  // Candidate User Footer (Gaming)
  if (token && userDetail?.role === 'candidate') {
    const candidateMenuItems = [
      { path: '/home', icon: <FaHome />, label: 'Home' },
      { path: '/play', icon: <FaGamepad />, label: 'Play' },
      { path: '/mywins', icon: <FaTrophy />, label: 'Wins' },
      { path: '/account', icon: <FaWallet />, label: 'Wallet' },
      { path: '/more', icon: <FaBars />, label: 'More' },
    ];

    return (
      <footer className="fixed bottom-0 left-0 right-0 w-full bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white shadow-[0_-4px_20px_rgba(0,0,0,0.3)] z-50 border-t border-gray-700">
        {/* Floating Balance Button */}
        {/* <div className="absolute -top-12 left-1/2 transform -translate-x-1/2">
          <div className="relative">
            <button
              onClick={() => navigate('/account')}
              className="bg-gradient-to-r from-yellow-500 to-orange-500 text-white px-4 py-2 rounded-full shadow-lg flex items-center gap-2 hover:scale-105 transition-transform duration-200"
            >
              <GiTwoCoins className="text-lg" />
              <span className="font-bold">
                ₹{coinDetails?.amount || '0.00'}
              </span>
            </button>

            <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-3 h-3 bg-gradient-to-r from-yellow-500 to-orange-500 rotate-45"></div>
          </div>
        </div> */}

        {/* Navigation */}
        <nav className="flex justify-around items-center py-3">
          {candidateMenuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center relative transition-all duration-300 ${
                isActive(item.path)
                  ? 'text-yellow-400 scale-110'
                  : 'text-gray-300 hover:text-white'
              }`}
            >
              {/* Active Indicator */}
              {isActive(item.path) && (
                <div className="absolute -top-3 w-10 h-1 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-b-full"></div>
              )}

              <div
                className={`icon-wrapper ${
                  isActive(item.path) ? 'active' : ''
                }`}
              >
                {item.icon}
              </div>

              <span className="text-xs font-semibold mt-1">{item.label}</span>

              {/* Special badge for Play */}
              {item.path === '/play' && (
                <div className="absolute -top-1 -right-1 w-5 h-5 bg-gradient-to-r from-red-500 to-pink-500 rounded-full flex items-center justify-center text-[10px] font-bold">
                  🔥
                </div>
              )}
            </Link>
          ))}
        </nav>
      </footer>
    );
  }

  return null;
};

export default Footer;
